import { ReactElement } from 'react';
import { connect } from 'react-redux';
import { AssessmentStatus, FragmentType, UserRole } from 'models/enum';
import { AppConstant, Locales } from 'constants/app.constant';
import { isDemoEmptyEhr } from 'helpers/assignment.helper';
import { appSelectors } from 'redux/ducks/app';

export interface ChartPermissionProps {
  fragmentCreatorId?: string | number | boolean | undefined;
  fragmentType?: FragmentType;
  children(arg: { allowSaveFragment?: boolean; allowEditFragment?: boolean; allowDeleteFragment?: boolean }): ReactElement;
  isAssessmentOwner: boolean;
  assessmentOwnerId: number;
  assessmentStatus: AssessmentStatus;
  isAuthor: boolean;
  userRole?: string;
  locale?: Locales;
  isInstructorSaveData?: boolean;
  isInstructorSaveDataUS?: boolean;
  loggedInUserId?: number;
}

const ChartPermission = (props: ChartPermissionProps) => {
  const { children, isAssessmentOwner, assessmentStatus, assessmentOwnerId, isAuthor, fragmentCreatorId, fragmentType, locale } = props;
  const isInDemoEmptyEhr = isDemoEmptyEhr();
  const isAssessmentChangeable = [AssessmentStatus.IN_PROGRESS, AssessmentStatus.PAST_DUE].includes(assessmentStatus);

  const allowEditFragment = isAssessmentOwner && isAssessmentChangeable && assessmentOwnerId === fragmentCreatorId;

  const isInstructorSaveData =
    (props.isInstructorSaveData && props.userRole === UserRole.INSTRUCTOR && locale === Locales.EN_AU && localStorage.getItem(AppConstant.IS_INSTRUCTOR_SAVE_DATA) === 'true') ||
    (props.isInstructorSaveDataUS && props.userRole === UserRole.INSTRUCTOR && locale === Locales.EN_US && localStorage.getItem(AppConstant.IS_INSTRUCTOR_SAVE_DATA_US) === 'true');
  const instructorSelfSaveData = props.userRole === UserRole.INSTRUCTOR && props.loggedInUserId === assessmentOwnerId && (locale === Locales.EN_AU || locale === Locales.EN_US);

  const allowSaveFragment =
    isAuthor || (isAssessmentOwner && isAssessmentChangeable && fragmentType !== FragmentType.AUTHORED) || isInDemoEmptyEhr || isInstructorSaveData || instructorSelfSaveData;

  return <>{children({ allowSaveFragment, allowEditFragment, allowDeleteFragment: allowEditFragment })}</>;
};

const mapStateToProps = (state) => ({
  isAssessmentOwner: appSelectors.getUserId(state) === appSelectors.getAssessment(state)?.studentId,
  assessmentOwnerId: appSelectors.getAssessment(state)?.studentId,
  assessmentStatus: appSelectors.getAssessment(state)?.status,
  isAuthor: appSelectors.getIsAuthor(state),
  userRole: appSelectors.getUserRole(state),
  isInstructorSaveData: appSelectors.getInstructorSaveData(state),
  isInstructorSaveDataUS: appSelectors.getInstructorSaveDataUS(state),
  locale: appSelectors.getLocale(state),
  loggedInUserId: appSelectors.getUserId(state)
});

ChartPermission.displayName = 'ChartPermission';
export { ChartPermission as BaseChartPermission };
export default connect(mapStateToProps)(ChartPermission);
